import { useState, useEffect } from 'react'
import PageHeader from '../../components/common/PageHeader'
import DynamicTable from '../../components/common/DynamicTable';
import CustomerFormModal from '../../components/modals/forms/CustomerFormModal';
import { listCustomers, createCustomer, editCustomer, deleteCustomer, showPassCode, showAPIKey } from '../../api/endpoints/customer';
import showSuccessAlert from '../../utils/swalAlerts/showSuccessAlert';
import showErrorAlert from '../../utils/swalAlerts/showErrorAlert';
import { showDeleteAlert } from '../../utils/swalAlerts/showDeleteAlert';
import { useNavigate, useParams } from 'react-router-dom';
import CustomerSettingFormModal from '../../components/modals/forms/CustomerSettingFormModal';
import CustomerSubscriptionFormModal from '../../components/modals/forms/customer/CustomerSubscriptionFormModal';
import { getUserInfo } from '../../utils/token';
//import { usePageSession } from '../context/PageSessionContext';

const List = () => {
  const { id: paramCompanyId } = useParams(); // 'id' from /:id/customer/list
  const [companyId, setCompanyId] = useState(null);
  const [customer, setCustomer] = useState([]);
  const [search, setSearch] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [settingModalVisible, setSettingModalVisible] = useState(false);
  const [ subscriptionModalVisible, setSubscriptionModalVisible ] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [listData, setListData] = useState([]);
  const navigate = useNavigate();
  

  useEffect(()=>{
    let compId = paramCompanyId;
    if(paramCompanyId){
      setCompanyId(paramCompanyId);
    }else{
      const {userId} = getUserInfo();
      compId = userId;
      setCompanyId(userId);
    }
    
    async function fetchData() {
      const response  = await listCustomers(compId);
      console.log(response);
      if(response.status === 200){
        console.log(response.data.data);
        setListData(response.data.data);
      }else{
        // show alert something went wrong
      }
    }
    fetchData();  
  },[]);

  const headerColumns = [
    { header: "Customer Name", accessor: "full_name",  render: (_, row) => `${row.customer_first_name} ${row.customer_last_name}` },
    { header: "Company Name", accessor: "customer_company_name"},
    
    { header: "Email", accessor: "email_id" },
    { header: "Mobile", accessor: "customer_mobile" },
    { header: "Credit" , accessor: "customer_acc.credit" },
    { 
      header: "Devices" , 
      accessor: "device_details", 
      render: (_, row) => {
        const active = row['customer_acc.active_devices'] ?? 0;
        const max = row['customer_acc.max_devices'] ?? 0;
        return `${active} / ${max}`;
      } 
    },
    {
      header: "Status",
      accessor: "customer_status",
      render: (value) => (
        <span className={`badge ${value === 1 ? "bg-success" : "bg-danger"}`}>
          {value === 1 ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  const handleAdd = () => {
    setSelectedId(null);
    setModalVisible(true);
  };

  const handleEdit = (row) => {
    setSelectedId(row.customer_id);
    setModalVisible(true);
  };

  const handlePasscode = (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to view the password?',
      message: '',
      confirmButtonText: 'Yes, Show!',
      isInfo: true,
      onConfirm: async () => {
        try {
          const response = await showPassCode(companyId, row.customer_id);
          console.log(response);
          if(response.status === 200){
            // send sucess 
            console.log(response.data);
            if(response.data.success){
              showSuccessAlert({
                title: "Password",
                message: atob(response.data.message),
                icon: "success",
                cancelText : 'Ok',
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleDelete = (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to delete this Customer?',
      message: 'This action is irreversible.',
      confirmButtonText: 'Yes, delete it!',
      onConfirm: async () => {
        try {
          const response = await deleteCustomer(companyId, row.customer_id);
          //console.log(response);
          if(response.status === 200){
            // send sucess 
            //console.log(response.data);
            if(response.data.success){

              showSuccessAlert({
                title: "Successful!",
                message: response.data.message,
                icon: "success",
                cancelText : 'Ok',
                onBack: () => window.location.reload(),
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleSave = async (customer) => {
    let response = {};
    let swalmsg = "";
    if (customer.customer_id) {
      setCustomer((prev) =>
        prev.map((c) => (c.comp_id === customer.customer_id ? customer : c))
      );
      delete customer.email_id;
      response = await editCustomer(customer);
      swalmsg = 'The Customer successfully editted.';
    } else {
      setCustomer((prev) => [...prev, { ...customer, customer_id: Date.now().toString() }]);
      delete customer.comp_id;
      response = await createCustomer(companyId, customer);      
    }
    console.log(response);
    if(response.status === 200 && response.data.success === true){
        showSuccessAlert({
          title: "Successful!",
          message: swalmsg,
          icon: "success",
          cancelText : 'Ok',
          onBack: () => window.location.reload(),
        })
      }else{
        showErrorAlert({
          title: "Oops...! Something went Wrong !",
          message: response?.validation?.body?.message,
          icon: "error",
        })
      }
    
  };

  const handleApiKeyView = (row) => {
    showDeleteAlert({
      title: 'Are you sure you want to view customer API key?',
      message: '',
      confirmButtonText: 'Yes, Show!',
      isInfo: true,
      onConfirm: async () => {
        try {
          const response = await showAPIKey(companyId, row.customer_id);
          if(response.status === 200){
            // send sucess 
            //console.log(response.data);
            if(response.data.success){
              showSuccessAlert({
                title: "API Key",
                message: response.data.message,
                icon: "success",
                cancelText : 'Ok',
              })
            }else{
              showErrorAlert({
                title: "Oops...! Something went Wrong !",
                message: "Please try after sometime.",
                icon: "error",
              })
            }
            
          }
          // Optionally refresh data or show success alert
        } catch (error) {
          console.error('Delete failed:', error);
          // Optionally show error alert
          showErrorAlert({
            title: "Oops...! Something went Wrong !",
            message: error.message,
            icon: "error",
          })
        }
      }
    });
  }

  const handleSetting = (row) => {
    setSelectedId(row.customer_id);
    setSettingModalVisible(true);
  }

  const handleSubscription = (row) => {
    setSelectedId(row.customer_id);
    //console.log(row.customer_id);
    setSubscriptionModalVisible(true);
  }

  const handleView = (row) => {
    console.log(row);
  }

  const handleSettingSave = (row) => {
    console.log(row);
  }

  return (
    <>
    <PageHeader  title="Customer List" breadcrumbs={[ {label: 'Administration'}, {label: 'Customer List'}]}/>
    <DynamicTable
      data={listData}
      columns={headerColumns}
      onAdd={handleAdd}
      onEdit={handleEdit}
      //onView={handleView}
      onDelete={handleDelete}
      onPassCode={handlePasscode}
      onDeleteMultiple={() => console.log("Bulk delete")}
      onApiKey={handleApiKeyView}
      onSetting={handleSetting}
      onSubscription={handleSubscription}
      //onHierarchy={handlehierarchy}
      //search={search}
      //onSearchChange={(e) => setSearch(e.target.value)}
    />

    <CustomerFormModal
        show={modalVisible}
        onClose={() => setModalVisible(false)}
        onSave={handleSave}
        compId={companyId}
        customerId={selectedId}
      />

      <CustomerSettingFormModal 
        show={settingModalVisible}
        onClose={() => setSettingModalVisible(false)}
        onSave={handleSettingSave}
        compId={companyId}
        customerId={selectedId}
      />

      <CustomerSubscriptionFormModal 
        show={subscriptionModalVisible}
        onClose={() => setSubscriptionModalVisible(false)}
        compId={companyId}
        customerId={selectedId}
      />

    </>
  )
}

export default List